import { createSlice } from "@reduxjs/toolkit";
import {
  fetchUserAccounts,
  updateUserStatus,
} from "./userAccounts.thunk";

const initialState = {
  users: [],
  totalPages: 1,
  currentPage: 1,
  total: 0,
  limit: 10,
  loading: false,
  error: null,
  selectedUser: null,
};

const userAccountsSlice = createSlice({
  name: "userAccounts",
  initialState,

  reducers: {
    setUserCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },

    setSelectedUser: (state, action) => {
      state.selectedUser = action.payload;
    },

    clearSelectedUser: (state) => {
      state.selectedUser = null;
    },
  },

  extraReducers: (builder) => {
    builder

      /* ================= FETCH ================= */
      .addCase(fetchUserAccounts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchUserAccounts.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload.data;
        state.totalPages = action.payload.meta.total_pages;
        state.total = action.payload.meta.total;
        state.limit = action.payload.meta.limit;
      })

      .addCase(fetchUserAccounts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ================= UPDATE STATUS ================= */
      .addCase(updateUserStatus.fulfilled, (state, action) => {
        const { id, is_active } = action.payload;

        // Optimistic update
        const user = state.users.find((u) => u.id === id);
        if (user) {
          user.is_active = is_active;
        }
      });
  },
});

export const {
  setUserCurrentPage,
  setSelectedUser,
  clearSelectedUser,
} = userAccountsSlice.actions;

export default userAccountsSlice.reducer;
